var render, staticRenderFns
import script from "./indexGoods.vue?vue&type=script&lang=js"
export * from "./indexGoods.vue?vue&type=script&lang=js"
import style0 from "./indexGoods.vue?vue&type=style&index=0&id=33e7bd9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e7bd9e",
  null
  
)

export default component.exports